import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {HarlequinGameConfig} from "../../HarlequinGameConfig";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Timeline, TimelineLite} from "gsap";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {HarlequinSoundConfig} from "../../HarlequinSoundConfig";


export class BonusIntroView extends BaseView {

    private _layer:ScalableLayer;
    private _wrapper:PIXI.Sprite;
    private _spine:PIXI.spine.Spine;


    constructor() {
        super();

        this._layer = StageManager.getLayer(HarlequinGameConfig.instance.LAYERS.BONUS_INTRO.name);
        this._layer.addChild(this);
    }

    initAnimations() {
        this.createBonusSpine();

        this.addChild(this._wrapper);
    }

    protected createBonusSpine():void {
        const wrapper:PIXI.Sprite = new PIXI.Sprite();
        const spine:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("harlequinBonusWon"));

        wrapper.anchor.set(0.5, 0.5);
        wrapper.addChild(spine);
        this._spine = spine;
        this._wrapper = wrapper;

        //console.log(spine.skeleton.data.animations);
        //this.playAnimation();
    }

    public playAnimation():Timeline {
        const tl:Timeline = new TimelineLite();

        tl.add(() => {
            this.renderable = true;
            SlotGame.sound.stopEffect(HarlequinSoundConfig.instance.ANTICIPATION);
            this._spine.state.setAnimation(0, "NewBaseGameToRespin", false);
        }, 0.2);
        tl.add(() => {
            this.renderable = false;
        }, "+=" + this._spine.skeleton.data.animations[0].duration);


        return tl;
    }

    protected onResize(resizeData: IResizeData): void {

        if(resizeData.orientation === Orientation.PORTRAIT) {
            this._wrapper.x = 360;
            this._wrapper.y = 100;
        }
        else {
            this._wrapper.x = 360;
            this._wrapper.y = 100;
        }
    }

    public hideAnimation():void {
        this.visible = false;
    }
}